import { createHashRouter } from "react-router-dom";

// import TablePage from "./pages/table";
import NotFound from "./pages/404";
import AdminUserServerManage from "./pages/admin-user-server-manage";
import UserServerManage from "./pages/user-server-manage";
import AdminServerManage from "./pages/admin-server-manage";

const router = createHashRouter([
  { path: "/", Component: UserServerManage },
  { path: "/manage-user-server", Component: AdminUserServerManage },
  { path: "/manage-server", Component: AdminServerManage },
  { path: "*", Component: NotFound },
  // {
  //   // Lifted blog splat route
  //   path: "/blog/*",
  //   children: [
  //     // New blog index route
  //     { index: true, Component: () => <h1>Blog Index</h1> },
  //     // Blog subapp splat route added for /blog/posts matching
  //     { path: "*", Component: BlogApp },
  //   ],
  // },
  // { path: "*", Component: Root },
]);

export default router;
